import type {FirebaseOptions} from 'firebase/app'

export type AppConfigName = 'goschool' | 'staging' | 'bme'

type AppConfig = {
  firebase: FirebaseOptions
  sentryDsn?: string
}

export const APP_CONFIGS: Record<AppConfigName, AppConfig> = {
  goschool: {
    firebase: {
      apiKey: 'AIzaSyCQ7ohfw06qt_L6LGvFlVLWJUlMm7Hjt9Q',
      authDomain: 'goschool-ai.firebaseapp.com',
      projectId: 'goschool-ai',
      storageBucket: 'goschool-ai.appspot.com',
      messagingSenderId: '873145289963',
      appId: '1:873145289963:web:b0c39b3d1c4efc6b2b42ae',
      measurementId: 'G-BXEL8ZTSQV'
    },
    sentryDsn: 'https://47cc4a138410414102abe3be71aa2700@o1019182.ingest.us.sentry.io/4507879037206528'
  },
  staging: {
    firebase: {
      apiKey: 'AIzaSyD38d6bC51XV1ZrzFpc8EADTCE1ehPnTXY',
      authDomain: 'goschool-staging.firebaseapp.com',
      projectId: 'goschool-staging',
      storageBucket: 'goschool-staging.firebasestorage.app',
      messagingSenderId: '7657797613',
      appId: '1:7657797613:web:c490a8d31534cd6bae59e4',
      measurementId: ''
    }
  },
  bme: {
    firebase: {
      apiKey: 'AIzaSyCQ7ohfw06qt_L6LGvFlVLWJUlMm7Hjt9Q',
      authDomain: 'edai.bme.hu',
      projectId: 'goschool-ai',
      storageBucket: 'goschool-ai.appspot.com',
      messagingSenderId: '873145289963',
      appId: '1:873145289963:web:b0c39b3d1c4efc6b2b42ae',
      measurementId: 'G-BXEL8ZTSQV'
    },
    sentryDsn: 'https://47cc4a138410414102abe3be71aa2700@o1019182.ingest.us.sentry.io/4507879037206528'
  }
}
